module.exports = __webpack_public_path__ + "img/bin.3553cb97.svg";